import {getSharePromotionShopCompanyInfo} from "@/servers/commodity/index";

const unlogin = {
  state: () => ({
    companyInfo: null
  }),
  mutations: {
    setShareCompanyInfo (state, info) {
      state.companyInfo = info
    }
  },
  actions: {
    async fetch_shareCompanyInfo({commit}, payload) {
      const res = await getSharePromotionShopCompanyInfo({
        supplierCompanyId: payload.id
      })
      if(!res) return;
      commit('setShareCompanyInfo',res)
    }
  },
  getters: {
    shareCompanyInfo(state) {
      return state.companyInfo
    }
  }
}

export default unlogin
